module.exports = __webpack_public_path__ + "fonts/BentonSansBBVA-BookItalic.c109f702.woff";